import stimulus from '../lib/stimulus-instance'
import CookiesAcceptanceMessage from './controllers/layout/cookies-acceptance-message'
import ShoppingCartController from './controllers/layout/shopping-cart-controller'
import SubscribeTonNewsletterController from
  '../../../components/subscribe_to_newsletter_component/subscribe-to-newsletter-controller'

stimulus.register('shopping-cart', ShoppingCartController)
stimulus.register('subscribe-to-newsletter', SubscribeTonNewsletterController)
stimulus.register('cookies-acceptance-message', CookiesAcceptanceMessage)
